<template>
    <div
        class="d-flex flex-column edit-title-form"
        :class="{ 'align-items-center': width > 600, 'aling-items-stretch': width < 600 }"
    >
        <p v-if="mode !== 'addTagsStep' && width > 600" class="edit-title">ADD VIBE & SOUND</p>
        <div
            v-if="width > 600"
            class="input-class"
            :class="{
                'flex-column-reverse m-0 w-100': mode === 'addTagsStep'
            }"
        >
            <div v-if="mode !== 'addTagsStep' && width > 600" class="input-value">
                <div class="tags" v-for="(item, index) in limitedValue" :key="index">
                    {{ item }}
                    <span class="tag-remove" @click="removeTag(index)">&#215;</span>
                </div>
            </div>
            <label v-if="mode === 'addTagsStep'" class="input-value d-flex align-items-center">
                <p class="vibe-text">The vibe is:</p>
                <div
                    :class="{
                        'tags-content': !mode,
                        'tags-create-event': mode === 'addTagsStep'
                    }"
                    v-for="(item, index) in limitedValue"
                    :key="index"
                >
                    {{ item }}
                    <span class="tag-remove" @click="removeTag(index)">&#215;</span>
                </div>
            </label>
            <p v-if="errorTags" class="error-text">Field required</p>
            <div class="vibe-container">
                <input
                    ref="tagsInput"
                    :class="{
                        'tags-input-booking': mode === 'addTagsStep',
                        'tags-input': !mode
                    }"
                    type="text"
                    placeholder="Add keywords that describe the event's vibe. Use commas to separate keywords."
                    v-model="selectedOption"
                    @keyup.enter="updateValue"
                    @focus="showOptions"
                />
                <button
                    @click="updateValue"
                    :style="{
                        background:
                            selectedOption && selectedOption.length ? '#cdeb09' : '#464646'
                    }"
                    class="add-vide-btn"
                >
                    Add
                </button>
            </div>
        </div>
        <button
            v-if="mode !== 'addTagsStep' && width > 600"
            @click="addNewTags"
            class="save-title-btn"
        >
            Save
        </button>
        <div v-if="width < 600" class="mobile-tags-fields">
            <textarea
                class="tags-text-area position-relative"
                ref="tagsInput"
                placeholder="Add keywords that describe the event's vibe. Use commas to separate keywords."
                @keyup.enter="updateValue"
                @focus="showOptions"
                v-model="selectedOption"
            >
            </textarea>
            <button
                @click="updateValue"
                class="create-event w-25"
                :style="{
                    background: selectedOption && selectedOption.length ? '#cdeb09' : '#464646'
                }"
            >
                Add
            </button>
            <div class="d-flex align-center flex-wrap py-3">
                <div class="input-tag-value">
                    <span class="vibe-text">The vibe is:</span>
                    <div
                        class="tag-item"
                        v-for="(item, index) in limitedValue"
                        :key="index"
                        @click="removeTag(index)"
                    >
                        {{ item }}
                        <span class="tag-remove">&#215;</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../helpers/notification'
    export default {
        name: 'AddEventTags',
        props: {
            eventData: {
                type: Object
            },
            mode: {
                type: String
            },
            locateTags: {
                type: Array
            },
            eventTags: {
                type: Array
            },
            width: {
                type: Number
            }
        },
        data: () => ({
            value: [],
            selectedOption: '',
            isVisible: false,
            errorTags: false
        }),
        methods: {
            async addNewTags() {
                try {
                    const response = await axios.put(
                        '/event/manage/update/' + this.eventData.id,
                        {
                            start: this.eventData.start,
                            start_time: this.eventData.start_time,
                            duration: this.eventData.duration,
                            recurring: this.eventData.recurring,
                            keywords: this.limitedValue.join(', ')
                        }
                    )
                    if (response.status === 200) {
                        const newEventData = {
                            id: this.eventData.id,
                            start: this.eventData.start,
                            start_time: this.eventData.start_time,
                            duration: this.eventData.duration,
                            recurring: this.eventData.recurring,
                            keywords: this.limitedValue.join(', ')
                        }
                        this.$emit('updateEventData', newEventData)
                    }
                    notification('success', response.data.message)
                } catch (error) {
                    notification('error', error)
                }
            },
            createEventsTag() {
                this.limitedValue.length
                    ? this.$emit('update:eventTags', this.limitedValue)
                    : (this.errorTags = true)
            },
            addAllTags() {
                this.limitedValue.length = 0
                this.limitedValue.push('All Genres')
                this.$emit('update:eventTags', this.limitedValue)
            },
            removeTag(index) {
                this.limitedValue.splice(index, 1)
            },
            updateValue() {
                if (this.selectedOption.trim() !== '') {
                    const tags = this.selectedOption.split(/[,;]/)
                    this.value.push(...tags.filter((tag) => tag.trim() !== ''))
                    this.selectedOption = ''
                    this.isVisible = true
                }
            },
            selectedTagValue(tag) {
                this.selectedOption = tag
                this.value.push(tag)
            },
            showOptions() {
                this.isVisible = !this.isVisible
            }
        },
        computed: {
            limitedValue() {
                return this.value
            }
        },
        watch: {
            limitedValue: function (newVal) {
                if (newVal.length) {
                    this.$emit('update:eventTags', newVal)
                    this.errorTags = false
                }
            }
        },
        created() {
            if (!this.limitedValue.length)
                this.mode === 'addTagsStep'
                    ? this.value.push(...this.eventTags)
                    : this.value.push(...this.locateTags)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .mobile-tags-fields {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .input-tag-value {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
    }
    .tags-text-area {
        display: flex;
        min-width: 343px;
        min-height: 99px;
        padding: 12px 15px 15px 15px;
        align-items: flex-start;
        gap: 20px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        overflow: hidden;
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        text-overflow: ellipsis;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .cancel-event {
        border: none;
        background: none;
        color: #8b8b8b;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss09' on, 'ss08' on, 'ss03' on, 'ss07' on, 'ss02' on;
        font-family: Studio Pro;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
    }
    .create-event {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: none;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .add-vide-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        border: 0;
    }
    .vibe-container {
        display: flex;
        align-items: center;
        gap: 25px;
    }
    .error-text {
        color: #c80000;
        padding: 10px 20px;
        margin: 0;
    }
    .vibe-text {
        color: #646464;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 20px;
        font-style: normal;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        margin: 0 10px 0 0;
    }
    .tag-item {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: #262626;
        color: #cdeb09;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        cursor: pointer;
    }
    .tags-input-booking {
        width: 100%;
        max-width: 887px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        color: #ffff;
        padding-left: 20px;
        min-height: 51px !important;
    }
    .edit-title {
        color: #ffffff;
        font-size: 21px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 3px;
        text-transform: uppercase;
    }
    .save-title-btn {
        display: inline-flex;
        padding: 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 100px;
        background: #d7eb5a;
        color: #1b0d29;
        text-align: center;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-weight: 500;
        letter-spacing: 1.8px;
        text-transform: uppercase;
        border: 0;
        width: 100%;
    }
    .input-class {
        display: flex;
        flex-direction: column;
        position: relative;
        margin-bottom: 30px;
    }
    .input-value {
        padding: 20px 0;
        gap: 10px;
        margin-bottom: 20px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.1em;
        font-feature-settings: 'calt' off;
        color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .tags-content {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.1em;
        color: #ffffff;
        background: rgba(22, 22, 22, 0.7);
        border-radius: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 2px 12px;
        text-transform: capitalize;
        border: 1px solid #fff;
        margin: 2px;
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .tags-create-event {
        border: 1px solid #cdeb09;
        background: #262626;
        color: #cdeb09;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 120%;
        border-radius: 20px;
        padding: 6px 6px 6px 14px;
        margin-right: 10px;
    }
    .tag-remove {
        display: inline-flex;
        cursor: pointer;
        color: rgb(236, 236, 236);
        margin-left: 4px;
        font-size: 22px;
    }
    .tags-input {
        border: 1px solid #b8b8b8;
        border-radius: 50px;
        height: 40px;
        padding-left: 30px;
        background: rgba(22, 22, 22, 0.7);
        color: #ffffff;
        position: relative;
        min-width: 366px;
    }
    .tags-input::placeholder {
        text-align: left;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.01em;
        font-feature-settings: 'calt' off;
        color: #ffffff;
    }
    .call-to-action-btns {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        gap: 24px;
    }
</style>
